<template>
  <div class="margin-bottom-s">
    <h5 class="margin-bottom-xs">
      {{ TRACK_PACKAGE.whereToGoText }}
    </h5>
    <div data-test-id="pickup-info" v-text="pickupInformation"></div>
  </div>
</template>

<script setup>
import { TRACK_PACKAGE } from 'config';

defineProps({
  pickupInformation: {
    type: String,
    default: '',
  },
});
</script>
